import { bool, string } from "prop-types";

import RichText from "../RichText/RichText.jsx";
import cx from "classnames";

const propTypes = {
  title: string,
  left: bool,
  right: bool,
  description: string,
  videoId: string.isRequired,
  playerType: string.isRequired,
  placeholderImg: string,
  demoTitleAndDescription: bool,
};

const VideoApiPlayer = (props) => {
  const {
    title,
    left,
    right,
    description,
    videoId,
    playerType,
    placeholderImg,
    demoTitleAndDescription
  } = props;

  let playerVar;
  if (playerType === "youtube") {
    playerVar = "js-youtube-player";
  } else if (playerType === "panopto") {
    playerVar = "js-panopto-player";
  } else if (playerType === "vimeo") {
    playerVar = "js-vimeo-player";
  } else if (playerType === "wistia") {
    playerVar = "js-wistia-player";
  } else {
    playerVar = null;
  }

  return (
    <section
      className="video-api-player"
    >
      {demoTitleAndDescription &&  
        <>
          <div className="component__header">
            <RichText>
              <h2>H2 headline style here</h2>
            </RichText>
          </div>
          <div className="component__description">
            <RichText>
              <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing. Nunc euismod ipsum non nisl scelerisque, eget lobortis ligula tempus.
              </p>
            </RichText>
          </div>
        </>
      }

      <div className={cx("video-api-player__container", {
        "--text-left": left,
        "--text-right": right,
      })}>
        {left && (title || description) && (
          <div className="video-api-player__text-content">
            {title && <h2 className="video-api-player__title h5">{title}</h2>}
            {description && (
              <div className="video-api-player__description">{description}</div>
            )}
          </div>
        )}
        <div
          data-id={videoId}
          className={"video-api-player__video-content " + playerVar}
        >
          <div className="video-api-player__aspect-ratio">
            {placeholderImg ? (
              <div className="video-api-player__poster">
                <img src={placeholderImg} alt="desc" loading="lazy" />
              </div>
            ) : null}

            {/* Video iframe gets placed in js-video-wrapper */}
            <div className="js-video-wrapper"></div>
            {placeholderImg ? (
              <button
                className="video-api-player__play js-video-api-play"
                type="button"
              >
                <span className="visually-hidden">Play video</span>
              </button>
            ) : null}
          </div>
        </div>

        {!left && (title || description) && (
          <div className="video-api-player__text-content">
            {title && <h2 className="video-api-player__title h5">{title}</h2>}
            {description && (
              <div className="video-api-player__description">{description}</div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

VideoApiPlayer.propTypes = propTypes;
export default VideoApiPlayer;
